import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useProjects = () => {
  const fetchContext = useContext(FetchContext);
  return useQuery("projects", async () => {
    const { data } = await fetchContext.authAxios.get(`/projects`);
    return data;
  });
};
